import React, { useState } from "react";
import InputTextSimple from "../../../../components/common/InputText/InputTextSimple";
import CheckBoxWithOutLabel from "../../../../components/common/checkbox/CheckboxWithoutLabel";
import ButtonOutlineFluid from "../../../../components/common/buttons/ButtonOutlineFluid";
import ButtonFluid from "../../../../components/common/buttons/ButtonFluid";
import Items from ".//..//..//..//..//assets//images//icons//items.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constants/Routes";
import InputNumbersSimple from "../../../../components/common/InputText/InputNumbersSimple";
import HttpHelper from "../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../constants/API_ROUTES";
import useAuth from "../../../../hooks/useAuth";
import { toast } from "react-toastify";

const ItemProfileCreate = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const zoneId = queryParams.get("zone-id");

  const { getAuth, clearAuth } = useAuth();
  const navigate = useNavigate();
  //Item Name
  const [targyNeve, setTargyNeve] = useState("");
  const [targyNeveError, setTargyNeveError] = useState("");
  //Electricians
  const [villanyszerelo, setVillanyszerelo] = useState(false);
  const [villanyszereloError, setVillanyszereloError] = useState("");
  //Kitchen Fitter
  const [konyhaszerelo, setKonyhaszerelo] = useState(false);
  const [konyhaszereloError, setKonyhaszereloError] = useState(false);
  //Dübel Arbeiten
  const [dubelArbeiten, setDubelArbeiten] = useState(false);
  const [dubelArbeitenError, setDubelArbeitenError] = useState(false);
  //Volumen
  const [volume, setVolume] = useState(0);
  const [volumeError, setVolumeError] = useState("");
  //Csomagolási idő /fő
  const [csomagolasiIdo, setCsomagolasiIdo] = useState(0);
  const [csomagolasiIdoError, setCsomagolasiIdoError] = useState("");
  //Buborékcsomagolási idő /fő
  const [buborekcsomagolasiIdo, setBuborekcsomagolasiIdo] = useState(0);
  const [buborekcsomagolasiIdoError, setBuborekcsomagolasiIdoError] = useState("");

  //Kicsomagolási idő /fő
  const [kicsomagolasiIdo, setKicsomagolasiIdo] = useState(0);
  const [kicsomagolasiIdoError, setKicsomagolasiIdoError] = useState("");

  //Szétszerelési idő /fő
  const [szetszerelesiIdo, setSzetszerelesiIdo] = useState(0);
  const [szetszerelesiIdoError, setSzetszerelesiIdoError] = useState("");

  //Összeszerelési idő /fő
  const [osszeszerelesiIdo, setOsszeszerelesiIdo] = useState(0);
  const [osszeszerelesiIdoError, setOsszeszerelesiIdoError] = useState("");

  const reset = () => {
    setTargyNeve("");
    setVillanyszerelo(false);
    setKonyhaszerelo(false);
    setDubelArbeiten(false);
    setVolume(0);
    setCsomagolasiIdo(0);
    setBuborekcsomagolasiIdo(0);
    setKicsomagolasiIdo(0);
    setSzetszerelesiIdo(0);
    setOsszeszerelesiIdo(0);

    setTargyNeveError("");
    setVillanyszereloError("");
    setKonyhaszereloError("");
    setDubelArbeitenError("");
    setVolumeError("");
    setCsomagolasiIdoError("");
    setBuborekcsomagolasiIdoError("");
    setKicsomagolasiIdoError("");
    setSzetszerelesiIdoError("");
    setOsszeszerelesiIdoError("");
  };

  const resetErrors = () => {
    setTargyNeveError("");
    setVillanyszereloError("");
    setKonyhaszereloError("");
    setDubelArbeitenError("");
    setVolumeError("");
    setCsomagolasiIdoError("");
    setBuborekcsomagolasiIdoError("");
    setKicsomagolasiIdoError("");
    setSzetszerelesiIdoError("");
    setOsszeszerelesiIdoError("");
  };
  const createItem = () => {
    resetErrors();

    HttpHelper.PostRequest({
      route: API_ROUTES.ZONE_ITEMS_CREATE,
      token: getAuth()?.bearerToken,
      parameters: {
        targyNeve,
        villanyszerelo,
        konyhaszerelo,
        dubelArbeiten,
        volume,
        csomagolasiIdo,
        buborekcsomagolasiIdo,
        kicsomagolasiIdo,
        szetszerelesiIdo,
        osszeszerelesiIdo,
        zoneId,
      },
    })
      .then((res) => {
        if (res.status == 200) {
          reset();
          toast.success("Zone Item successfully updated !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status == 422) {
          const messages = res.message;
          for (const key in messages) {
            if (messages.hasOwnProperty(key) && Array.isArray(messages[key]) && messages[key].length > 0) {
              const errorMessage = messages[key][0];
              if (key === "targyNeve") {
                setTargyNeveError(errorMessage);
              } else if (key === "villanyszerelo") {
                setVillanyszereloError(errorMessage);
              } else if (key === "konyhaszerelo") {
                setKonyhaszereloError(errorMessage);
              } else if (key === "dubelArbeiten") {
                setDubelArbeiten(errorMessage);
              } else if (key === "volume") {
                setVolumeError(errorMessage);
              } else if (key === "csomagolasiIdo") {
                setCsomagolasiIdoError(errorMessage);
              } else if (key === "bubbleWrapping") {
                setBuborekcsomagolasiIdoError(errorMessage);
              } else if (key === "kicsomagolasiIdo") {
                setKicsomagolasiIdoError(errorMessage);
              } else if (key === "szetszerelesiIdo") {
                setSzetszerelesiIdoError(errorMessage);
              } else if (key === "osszeszerelesiIdo") {
                setOsszeszerelesiIdo(errorMessage);
              }
            }
          }
        } else if (res.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Unknown error !", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };
  return (
    <>
      <div className="px-[1rem] sm:px-[1.875rem] mt-[3rem]">
        <div className=" mt-[3rem]  flex flex-row justify-between items-center ">
          <div className="flex flex-row items-center gap-[1rem] sm:gap-[1.875rem]">
            <Link to={`${ROUTES.ADMIN_ZONE_ITEMS}?zone-id=${zoneId}`}>
              <i className="bg-[rgba(6,85,103,0.5)] min-h-[4.3rem] min-w-[4.3rem] rounded-full flex justify-center items-center">
                <img src={Items} alt="items icon" className="w-[2.5rem] " />
              </i>
            </Link>
            <div>
              <h2 className="font-bold font-lato text-[2rem] sm:text-[3.125rem] leading-normal">
                Sitzgruppe (Anzahl Sitze)
              </h2>
              <p className="text-[#BDBDBD] text-[1rem] font-bold font-lato">Wohnzimmer</p>
            </div>
          </div>
        </div>
        {/* Header Start */}
        <div className="mt-[3rem] flex flex-row  justify-between gap-4 ">
          <div className="w-full lg:w-1/2">
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem]  font-lato font-normal leading-normal">Tárgy neve</label>
              <InputTextSimple
                placeholder={``}
                variant="light"
                value={targyNeve}
                error={targyNeveError}
                onChange={(e) => setTargyNeve(e.target.value)}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem]  font-lato font-normal leading-normal">Villanyszerelő</label>
              <CheckBoxWithOutLabel
                value={"villanyszerelo"}
                checked={villanyszerelo}
                name={"villanyszerelo"}
                id={"villanyszerelo"}
                error={villanyszereloError}
                onClick={(e) => {
                  setVillanyszerelo(!villanyszerelo);
                }}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem]   font-lato font-normal leading-normal">Konyhaszerelő</label>
              <CheckBoxWithOutLabel
                checked={konyhaszerelo}
                value={"konyhaszerelo"}
                id={`konyhaszerelo`}
                name={`konyhaszerelo`}
                error={konyhaszereloError}
                onClick={(e) => {
                  setKonyhaszerelo(!konyhaszerelo);
                }}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Dübel Arbeiten</label>
              <CheckBoxWithOutLabel
                checked={dubelArbeiten}
                value={"dubelArbeiten"}
                id={`dubelArbeiten`}
                name={`dubelArbeiten`}
                error={dubelArbeitenError}
                onClick={(e) => {
                  setDubelArbeiten(!dubelArbeiten);
                }}
              />
            </div>

            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Volumen (m3)</label>
              <InputNumbersSimple
                placeholder={``}
                variant="light"
                id={"volume"}
                name={"volume"}
                value={volume}
                error={volumeError}
                onChange={(e) => setVolume(e.target.value)}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Csomagolási idő /fő</label>
              <InputNumbersSimple
                placeholder={``}
                variant="light"
                id={"csomagolasiIdo"}
                name={"csomagolasiIdo"}
                value={csomagolasiIdo}
                error={csomagolasiIdoError}
                onChange={(e) => setCsomagolasiIdoError(e.target.value)}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                Buborékcsomagolási idő /fő
              </label>
              <InputNumbersSimple
                placeholder={``}
                variant="light"
                id={"buborekcsomagolasiIdo"}
                name={"buborekcsomagolasiIdo"}
                value={buborekcsomagolasiIdo}
                error={buborekcsomagolasiIdoError}
                onChange={(e) => setBuborekcsomagolasiIdo(e.target.value)}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                Kicsomagolási idő /fő
              </label>
              <InputNumbersSimple
                placeholder={``}
                variant="light"
                id={"kicsomagolasiIdo"}
                name={"kicsomagolasiIdo"}
                value={kicsomagolasiIdo}
                error={kicsomagolasiIdoError}
                onChange={(e) => setKicsomagolasiIdo(e.target.value)}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                Szétszerelési idő /fő
              </label>
              <InputNumbersSimple
                placeholder={``}
                variant="light"
                id={"szetszerelesiIdo"}
                name={"szetszerelesiIdo"}
                value={szetszerelesiIdo}
                error={szetszerelesiIdoError}
                onChange={(e) => setSzetszerelesiIdo(e.target.value)}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                Összeszerelési idő /fő
              </label>
              <InputNumbersSimple
                placeholder={``}
                variant="light"
                id={"osszeszerelesiIdo"}
                name={"osszeszerelesiIdo"}
                value={osszeszerelesiIdo}
                error={osszeszerelesiIdoError}
                onChange={(e) => setOsszeszerelesiIdo(e.target.value)}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <div></div> <div></div>
              <div className="flex flex-row gap-5 mt-12 mb-12 text-center">
                <ButtonFluid label={`Mentés`} onClick={createItem} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemProfileCreate;
